import React from "react";
import { Modal, Grid } from "antd";
import DetailReport from "../pages/ReportDetail";

const { useBreakpoint } = Grid;

export default function DetailLaporanModal({
  open,
  id_laporan,
  asset_name,
  onClose,
}) {
  const screens = useBreakpoint();
  const modalWidth = screens.lg ? "80vw" : "100vw";

  return (
    <Modal
      open={open}
      title={`Detail Laporan ${asset_name}`}
      onCancel={onClose}
      footer={null}
      width={modalWidth}
      // style={{ top: 20 }}
      centered
      styles={{
        body: {
          maxHeight: "80vh",
          overflowY: "auto",
          //   padding: 24,
        },
      }}
    >
      <DetailReport id_laporan={id_laporan} />
    </Modal>
  );
}
